export { default as reduceToDigit } from './reduceToDigit'
export { default as removeSpaceAndTransformToLowerCase } from './removeSpaceAndTransformToLowerCase'
export { default as upperCaseTheFirstLetter } from './upperCaseTheFirstLetter'
export { default as validateEmail } from './validateEmail'
